import { PulseLoader } from "react-spinners";

const FetchDataWithLoader = () => {
  return (
    <div
      style={{
        marginTop: "3rem",
        marginBottom: "3rem",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <PulseLoader color="#36d7b7" size={15} />
    </div>
  );
};

export default FetchDataWithLoader;
